import { Settings } from './types';
import jsonp from 'jsonp';
import OneSignal from "../types/OneSignal";
import Log from "../Log";

export default class SettingsManager {
  /**
   * Loads the settings using the OneSignal API.
   * Handles the error messages in case there was an
   * error during retrieval.
   *
   * The settings aren't saved in local storage as that could
   * result in inconsistencies should the user change any of the
   * settings in the UI.
   */
  public static async load(appId: string): Promise<Settings | undefined> {
    try {
      const settings: Settings = await this.loadFromApi(appId);
      return settings;
    } catch (err) {
      Log.debug('Settings: Failed to retrieve Shopify Settings from API', err);
      return undefined;
    }
  }

  /**
   * Loads the shopify settings from the API.
   *
   * @param appId The app id the settings will be loaded for
   */
  private static async loadFromApi(appId: string): Promise<Settings> {
    // return the object for the config
    return new Promise<Settings>((resolve, reject) => {
      const settingsUrl = this.buildSettingsPath(appId);

      jsonp(settingsUrl, undefined, (err, data) => {
        if (err) {
          return reject(err);
        } else {
          if (data.success) {
            return resolve(data.payload);
          } else {
            return reject(data);
          }
        }
      });
    });
  }

  /**
   * Returns the url for the API call that will retrieve settings
   *
   * @param appId
   */
  private static buildSettingsPath(appId: string): string {
    const apiUrl = (window.OneSignal as OneSignal).sdkEnvironment.getOneSignalApiUrl().toString();
    return `${apiUrl}/sync/${appId}/shopify`;
  }
}
